import type { AssetListStatus } from "@pax/api-contract/assets/v1alpha1";
import { createFileRoute } from "@tanstack/react-router";
import { MyAssetsScreen } from "@/features/assets/components/MyAssetsScreen";

export const Route = createFileRoute("/_authenticated/assets/mine")({
  validateSearch: (search: Record<string, unknown>): { status?: AssetListStatus } =>
    search.status === "draft" || search.status === "published" ? { status: search.status } : {},
  staticData: { access: "account" },
  head: () => ({ meta: [{ title: "My assets · Pax.co" }] }),
  component: MyAssetsPage,
});

function MyAssetsPage() {
  const { status } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <MyAssetsScreen
      status={status}
      onStatusChange={next =>
        void navigate({ search: next ? { status: next } : {}, replace: true, resetScroll: false })
      }
    />
  );
}
